// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error505_wrapper__zWemW","title":"Error505_title__RkwT1","subtitle":"Error505_subtitle__q1Rz4","button":"Error505_button__CXJOT"};